import React, { useEffect, useState } from 'react';

import { Button, Form, Container } from 'react-bootstrap';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setPlantInfo, setName, setAddress, setCallNumber, updateTime } from '../../store';
import io from 'socket.io-client';

import JBSetting from './JBSetting';
import IVSetting from './IVSetting';
import EVSetting from './EnvironmentSetting';
import EtcSetting from './EtcSetting';
import LogoManager from './LogoManager';

import { fetchSettings } from '../../store';
import config from '../../config';
import LhSetting from './LhSetting';
import DashBoardSetting from './DashBoardSetting';
import AcbSetting from './AcbSetting';
import { handleRealTimeDataIv, handleRealTimeDataEv, handleRealTimeDataJbMrt, handleRealTimeDataAcb, handleRealTimeDataDashboard } from '../../public/websocketHandler'; // 새로운 파일에서 함수 임포트







/*
 *******************************************************************
 *                                                                 *
 *  FUNCTION: SiteInfoInput                                        *
 *  DESCRIPTION: 현장명 전화번호 날짜 및 시간 수정                    *  
 *                                                                 *
 *                                                                 *
 *******************************************************************
 */
const SiteInfoInput = () => {
  const dispatch = useDispatch();
  const plantInfo = useSelector((state) => state.plantInfo);
  const systemTime = useSelector((state) => state.systemTime);
  const [dateTime, setDateTime] = useState(''); // 초기값은 빈 문자열
  const [isLoaded, setIsLoaded] = useState(false); // 데이터 로딩 상태

  // 최초 장비 리스트 불러오기
  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);


  useEffect(() => {
    axios.get(`${config.backendUrl}/api/get-info`)
      .then(response => {
        // console.log('Fetched data:', response.data); // 디버깅 로그
        dispatch(setPlantInfo(response.data));

        if (response.data.dateTime) {
          // 받아온 시간을 포맷팅하여 사용
          setDateTime(formatToKST(response.data.dateTime, true));
        } else {
          const now = new Date();
          setDateTime(formatToKST(now));
        }
        setIsLoaded(true); // 데이터 로딩 완료
      })
      .catch(error => {
        console.error('There was an error fetching the info!', error);
      });
  }, [dispatch]);

  useEffect(() => {
    if (systemTime && systemTime.nowtime && isLoaded) {
      setDateTime(formatToKST(systemTime.nowtime));
    }
  }, [systemTime, isLoaded]);

  useEffect(() => {
    const socket = io(`${config.backendUrl}`, {
      transports: ['websocket']
    });

    socket.on('connect', () => {
      // console.log('Connected to WebSocket server');
      socket.emit('request_time'); // 서버에 시간 요청 이벤트 전송 (한 번만 호출)
    });

    socket.on('system_time', (data) => {
      if (data.nowtime) {
        dispatch(updateTime(data)); // Redux 상태 업데이트
      }
    });

    // 리얼타임값이 웹소켓으로 들어오면 리덕스 업데이트함

    socket.on('real_time_data_inverter', (message) => {
      handleRealTimeDataIv(message, dispatch);  
    });

    socket.on('real_time_data_Sensor', (message) => {
      handleRealTimeDataEv(message, dispatch);  
    });

    socket.on('real_time_data_JbMrt', (message) => {
      handleRealTimeDataJbMrt(message, dispatch);  
    });

    socket.on('real_time_data_ACB', (message) => {
      handleRealTimeDataAcb(message, dispatch);  
    });

    socket.on('real_time_data_dashboard', (message) => {
      handleRealTimeDataDashboard(message, dispatch);  
    });




    return () => {
      socket.off('system_time');
      socket.off('real_time_data_inverter');
      socket.off('real_time_data_Sensor');
      socket.off('real_time_data_JbMrt');
      socket.off('handleRealTimeDataAcb');
      socket.off('real_time_data_dashboard');


      socket.off('connect');
      socket.close(); // 소켓 연결 해제
    };
  }, [dispatch]);

  const handleNameChange = (e) => {
    dispatch(setName(e.target.value));
  };

  const handleAddressChange = (e) => {
    dispatch(setAddress(e.target.value));
  };

  const handleCallNumberChange = (e) => {
    dispatch(setCallNumber(e.target.value));
  };

  const handleDateTimeChange = (e) => {
    setDateTime(e.target.value);
  };

  const handleSave = () => {
    if (plantInfo.name.length > 50) {
      alert('현장명은 50자를 넘을 수 없습니다.');
      return;
    }

    const callNumberRegex = /^\d{3}-\d{3,4}-\d{4}$/;
    if (!callNumberRegex.test(plantInfo.callnumber)) {
      alert('전화번호 형식이 올바르지 않습니다. (예: 010-1234-5678)');
      return;
    }

    axios.post(`${config.backendUrl}/api/update-info`, {
      name: plantInfo.name,
      address: plantInfo.address,
      callnumber: plantInfo.callnumber,
      logo: plantInfo.logo,  // 로고 정보 추가
    })
      .then(response => {
        alert('정보가 성공적으로 저장되었습니다.');
      })
      .catch(error => {
        console.error('There was an error saving the info!', error);
        alert('정보 저장에 실패했습니다.');
      });
  };

  const handleSaveDateTime = () => {
    axios.post(`${config.backendUrl}/api/set-systemTime`, { new_time: dateTime })
      .then(response => {
        if (response.data.success) {
          alert('시스템 시간이 성공적으로 설정되었습니다.');
        } else {
          alert('시스템 시간 설정에 실패했습니다.');
        }
      })
      .catch(error => {
        console.error('There was an error setting the system time!', error);
        alert('시스템 시간 설정에 실패했습니다.');
      });
  };

  const handleSetCurrentTime = () => {
    const now = new Date();
    setDateTime(formatToKST(now));
  };

  // 한국 시간으로 변환하고, YYYY-MM-DD HH:MM:SS 또는 YYYY MM/DD (요일) HH:MM:SS 형식으로 포맷팅하는 함수
  const formatToKST = (date, isInitial = false) => {
    const kstTime = new Date(new Date(date).getTime() + (9 * 60 * 60 * 1000)); // UTC+9로 변환
    const options = { weekday: 'short' }; // 요일 표시를 위한 옵션
    const dayOfWeek = new Intl.DateTimeFormat('ko-KR', options).format(kstTime); // 요일 구하기

    if (isInitial) {
      // 최초 접속 시 형식: YYYY MM/DD (요일) HH:MM:SS
      return `${kstTime.getFullYear()} ${kstTime.getMonth() + 1}/${kstTime.getDate()} (${dayOfWeek}) ${kstTime.toTimeString().split(' ')[0]}`;
    } else {
      // 기본 형식: YYYY-MM-DD HH:MM:SS
      return kstTime.toISOString().slice(0, 19).replace('T', ' ');
    }
  };

  return (
    <Container className="mt-5">
      <div className="d-flex align-items-center mb-3">
        <div className="d-flex align-items-center mb-2" style={{ marginRight: '20px' }}>
          <Form.Label htmlFor="siteNameInput" className="mr-2 mb-0">
            현장명
          </Form.Label>
          <Form.Control
            id="siteNameInput"
            type="text"
            placeholder="현장명을 입력하세요"
            value={plantInfo.name}
            onChange={handleNameChange}
            className="mr-2"
            style={{ flex: '1' }}
          />
        </div>
        <div className="d-flex align-items-center mb-2" style={{ marginRight: '20px' }}>
          <Form.Label htmlFor="siteAddressInput" className="mr-2 mb-0">
            현장 주소
          </Form.Label>
          <Form.Control
            id="siteAddressInput"
            type="text"
            placeholder="현장 주소를 입력하세요"
            value={plantInfo.address}
            onChange={handleAddressChange}
            className="mr-2"
            style={{ flex: '2', width: '500px', height: '40px' }}
          />
        </div>
        <div className="d-flex align-items-center mb-2" style={{ marginRight: '20px' }}>
          <Form.Label htmlFor="callNumberInput" className="mr-2 mb-0">
            전화번호
          </Form.Label>
          <Form.Control
            id="callNumberInput"
            type="text"
            placeholder="전화번호를 입력하세요 (예: 010-1234-5678)"
            value={plantInfo.callnumber}
            onChange={handleCallNumberChange}
            style={{ flex: '1', width: '200px', height: '40px' }}
          />
        </div>
        <Button variant="primary" onClick={handleSave}>
          현장 전화번호<br/>
          저장
        </Button>
      </div>
      <div className="d-flex align-items-center mb-3" style={{ maxWidth: '100%' }}>
        <LogoManager />
        <div className="d-flex align-items-center" style={{ width: '1300px' }}>
          <Form.Label htmlFor="dateTimeInput" className="mr-2 mb-0">날짜 및 시간</Form.Label>
          <Form.Control
            id="dateTimeInput"
            type="text"
            placeholder="YYYY-MM-DD HH:MM:SS"
            value={isLoaded ? dateTime : ''}
            onChange={handleDateTimeChange}
            className="mr-2"
            style={{ flex: 1, height: '40px', fontSize: '1em' }}
          />
          <Button variant="secondary" onClick={handleSaveDateTime} className="mr-2" size="sm">
            날짜 및 시간 저장
          </Button>
          <Button variant="info" onClick={handleSetCurrentTime} size="sm">
            현재 시간 불러오기
          </Button>
        </div>
      </div>
        {/* LH 세팅 */}
        <LhSetting />
        {/* {인버터 세팅} */}
        <IVSetting/> 
        {/* {환경센서 세팅} */}
        <EVSetting/>
        {/* {접속함 세팅} */}
        <JBSetting/>
        {/* {기타 장비  세팅} */}
        <EtcSetting/>
        {/* 현황판 세팅 */}
        <DashBoardSetting/>
        {/* 기중차단기 세팅 */}
        <AcbSetting/>
    </Container>
  );
};






export default SiteInfoInput;
